import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const Layout = (props) => {
  const { showFooter } = useSelector((state) => state.auth);
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname]);

  return (
    <div>
      <Header history={props.history} />
      <div style={{ paddingTop: "62px", minHeight: "75vh" }}>
        {props.children}
      </div>
      {showFooter && <Footer />}
    </div>
  );
};

export default Layout;
